import { Fetch } from '../shared/general';

//#region ======== ACTIONS ========
const actions = {
    //======== CLAIM MANAGEMENT ======
    holiday_holiday_create      : "holiday_holiday_create",
    holiday_list_get            : "holiday_list_get",
    holiday_holiday_update      : "holiday_holiday_update",
    holiday_date_get            : "holiday_date_get"
};
//#endregion

//#region ========== API FUNCTIONS ===========
export function holiday_holiday_create(data){
    return Fetch({ action: actions.holiday_holiday_create, data: data });
}

export function holiday_list_get(data){
    return Fetch({ action: actions.holiday_list_get, data: data });
}

export function holiday_holiday_update(data){
    return Fetch({ action: actions.holiday_holiday_update, data: data });
}

export function holiday_date_get(data){
    return Fetch({ action: actions.holiday_date_get, data: data });
}